/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import ApexCharts from "apexcharts";
import { DropdownCustomToggler, DropdownMenu2 } from "../../dropdowns";
import { useHtmlClassService } from "../../../layout";
import { toAbsoluteUrl } from "../../../_helpers";

export function MixedWidget4({
  className,
  chartColor = "primary",
  customColor = "#ffffff",
  bgColor = "dark",
  iconUrl = "/media/svg/icons/Layout/Layout-4-blocks.svg",
  chartId,
  title,
  totalCount,
  currentState,
  data,
  labels,
  maxValue = 100,
  showAll = false
}) {
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray500: objectPath.get(
        uiService.config,
        "js.colors.gray.gray400"
      ),
      colorsGrayGray200: objectPath.get(
        uiService.config,
        "js.colors.gray.gray200"
      ),
      colorsThemeBaseColor: objectPath.get(
        uiService.config,
        `js.colors.theme.base.${chartColor}`
      ),
      colorsThemeLightColor: objectPath.get(
        uiService.config,
        `js.colors.theme.light.${chartColor}`
      ),
      fontFamily: objectPath.get(uiService.config, "js.fontFamily"),
    };
  }, [uiService, chartColor]);

  useEffect(() => {
    const element = document.getElementById(chartId);

    if (!element) {
      return;
    }

    const options = getChartOption(layoutProps, data, labels, title, maxValue, customColor);
    const chart = new ApexCharts(element, options);
    chart.render();
    return function cleanUp() {
      chart.destroy();
    };
  }, [layoutProps]);

  return (
    <>
      {/* begin::Tiles Widget 1 */}
      <div
        className={`card card-custom bg-radial-gradient-${bgColor} ${className}`}
      >
        {/* begin::Header */}
        <div className={`card-header border-0 pt-5 text-${chartColor}`}>
          <div>
            <h3 className="card-title font-weight-bolder text-primary">
              {totalCount} نفر
            </h3>
            <span className="font-size-sm text-primary font-weight-bold mt-2">
              {title}
            </span>
            {/* <span className="text-muted font-weight-bold mt-2">
            {title}
          </span> */}
          </div>

          <div className="card-toolbar">
            <span className={`svg-icon svg-icon-xl svg-icon-${chartColor}`}>
              <SVG
                src={toAbsoluteUrl(iconUrl)}
              ></SVG>
            </span>
            {/* <Dropdown className="dropdown-inline" alignRight>
              <Dropdown.Toggle
                className="btn btn-text-white btn-hover-white btn-sm btn-icon border-0"
                variant="transparent"
                id="dropdown-toggle-top"
                as={DropdownCustomToggler}
              >
                <i className="ki ki-bold-more-hor" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                <DropdownMenu2 />
              </Dropdown.Menu>
            </Dropdown> */}
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body d-flex flex-column p-0 mt-5">
          {/* begin::Chart */}
          <div
            id={chartId}
            data-color={chartColor}
            style={{ height: "160px" }}
          />
          {/* end::Chart */}

          {/* begin::Stats */}

          {showAll &&
            <div className="card-spacer bg-light card-rounded flex-grow-1">
              <div className="row m-0">

                <div className="col px-8 py-6 mr-8">
                  <div className="font-size-sm text-muted font-weight-bold">
                    جمع همه
                  </div>
                  <div className="font-size-h6 font-weight-bolder">{totalCount}</div>
                </div>

                {labels.map((item, index) =>
                  <div key={index} className="col px-8 py-6 ">
                    <div className="font-size-sm text-muted font-weight-bold">
                      {item}
                    </div>
                    <div className="font-size-h4 font-weight-bolder">{data[index]}</div>
                  </div>
                )}
              </div>
            </div>
          }
          {/* end::Stats */}

        </div>

        {/* end::Body */}
      </div>
      {/* end::Tiles Widget 1 */}
    </>
  );
}

function getChartOption(layoutProps, data, labels, title, maxValue, customColor) {
  const options = {
    series: [
      {
        name: title,
        data: data,
      },
      // {
      //   name: "Revenue",
      //   data: data,
      // },
    ],

    chart: {
      type: "bar",
      height: "160px",
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: ["30%"],
        endingShape: "rounded",
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    xaxis: {
      categories: labels,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: layoutProps.colorsGrayGray500,
          fontSize: "12px",
          fontFamily: layoutProps.fontFamily,
        },
      },
    },
    yaxis: {
      min: 0,
      max: { maxValue },
      labels: {
        style: {
          colors: layoutProps.colorsGrayGray500,
          fontSize: "12px",
          fontFamily: layoutProps.fontFamily,
        },
      },
    },
    fill: {
      type: ["solid"],
      opacity: [0.8],
      // type: ["solid", "solid"],
      // opacity: [0.8, 0.4],
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: "12px",
        fontFamily: layoutProps.fontFamily,
      },
      y: {
        formatter: function (val) {
          return val + " نفر";
        },
      },
      marker: {
        show: false,
      },
    },
    colors: [customColor],
    grid: {
      borderColor: layoutProps.colorsGrayGray200,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        left: 20,
        right: 20,
      },
    },
  };
  return options;
}
